export default __webpack_public_path__ + "static/media/c4.94cadf3f.png";